import { jsx } from "react/jsx-runtime";
import { themes } from "../../themes/index.mjs";
import { BraidProvider } from "../BraidProvider/BraidProvider.mjs";
import { BraidTestProviderContext } from "./BraidTestProviderContext.mjs";
import { breakpointContext } from "../BraidProvider/BreakpointContext.mjs";
const BraidTestProvider = ({
  themeName = "wireframe",
  breakpoint = null,
  ...restProps
}) => /* @__PURE__ */ jsx(BraidTestProviderContext.Provider, { value: true, children: /* @__PURE__ */ jsx(breakpointContext.Provider, { value: breakpoint, children: /* @__PURE__ */ jsx(
  BraidProvider,
  {
    ...restProps,
    theme: themes[themeName],
    styleBody: void 0
  }
) }) });
export {
  BraidTestProvider
};
